// extracted by mini-css-extract-plugin
export default {"container":"statistic-block_container__YFSB-","card":"statistic-block_card__PFtmk","icon":"statistic-block_icon__W3rS8","title":"statistic-block_title__ZAWtF"};